import { webConfig } from '@/config'

const state = {
  ...webConfig
}

export default { state }
